import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ml-auto" }
const _hoisted_2 = ["textContent"]

import { computed, onMounted, ref, Ref } from 'vue';
import Chip from 'primevue/chip';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import ArchiveSwitch from '@/components/ArchiveSwitch';
import AddPersonModal from '@/components/AddPersonModal/AddPersonModal.vue';
import { useArchiveStore, useCaseManagerStore } from '@/store';
import { CaseManagerModal, CaseManagerTable } from '@/types';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum/permissions';


export default /*@__PURE__*/_defineComponent({
  __name: 'CaseManagersTable',
  setup(__props) {

const caseManagerStore = useCaseManagerStore();
const archiveStore = useArchiveStore();
const caseManagers: Ref<CaseManagerTable[]> = ref([]);
const caseManagerCount: Ref<number> = computed(() => (caseManagers.value ? caseManagers.value.length : 0));
const caseManagerModalOpen: Ref<boolean> = ref(false);
const archivedVisible = ref(false);
const caseManagerItems: Ref<CaseManagerModal[]> = ref([]);

onMounted((): void => {
  if (can([PERMISSIONS.ORGANIZATION_CASE_MANAGER_INDEX])) getCaseManagers(false);
});

const getCaseManagers: (showArchived: boolean) => Promise<void> = async (showArchived: boolean) => {
  const filterArchived = showArchived ? '?archived=1' : '';
  await caseManagerStore
    .getCaseManagersForTable(filterArchived)
    .then((result) => (caseManagers.value = result))
    .catch((e) => {
      caseManagers.value = [];
      throw e;
    });
};

const createMenuModel = (item: CaseManagerTable) => {
  const menuItems = [
    {
      label: 'Remove Case Manager',
      visible: can([PERMISSIONS.ORGANIZATION_DETACH_CASE_MANAGERS]),
      command: () => {
        detachCaseManager([item.id], item.name);
      },
    },
  ];
  if (item.archived) {
    menuItems.push({
      label: 'Unarchive',
      visible: can([PERMISSIONS.PEOPLE_ARCHIVE]),
      command: async () => {
        await archiveStore.unarchive(item.id);
        archiveStore.doToast(`${item.name} has been restored`, 'Unarchived');
      },
    });
  }
  return menuItems;
};

const attachCaseManagers: (ids: number[]) => Promise<void> = async (ids) => {
  await caseManagerStore.attachCaseManagers(ids);
  getCaseManagers(false);
  caseManagerStore.doToast('Case Manager(s) has been added', 'Added');
};

const detachCaseManager: (ids: number[], caseManagerName: string) => Promise<void> = async (ids, caseManagerName) => {
  await caseManagerStore.detachCaseManagers(ids);
  getCaseManagers(false);
  caseManagerStore.doToast(`${caseManagerName} has been removed from organization`, 'Removed');
};

const openAddCaseManagerModal = async () => {
  caseManagerModalOpen.value = true;
  caseManagerItems.value = await caseManagerStore.getCaseManagersAvailableToAdd();
};

const onCancelAdd = () => (caseManagerModalOpen.value = false);

const onSaveAdd = (caseManagers: CaseManagerModal[]) => {
  let caseManagerIds = caseManagers.map((caseManager) => {
    return caseManager.value;
  });
  attachCaseManagers(caseManagerIds);
  caseManagerModalOpen.value = false;
};
const showArchived = () => {
  archivedVisible.value = true;
  caseManagerStore.showArchived = true;
  getCaseManagers(true);
};
const hideArchived = () => {
  archivedVisible.value = false;
  caseManagerStore.showArchived = false;
  getCaseManagers(false);
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ActionMenu = _resolveComponent("ActionMenu")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Case Managers", -1)),
      _createVNode(_unref(Chip), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(caseManagerCount.value), 1)
        ]),
        _: 1
      }),
      (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_CASE_MANAGER_SHOW_ARCHIVED]))
        ? (_openBlock(), _createBlock(_unref(ArchiveSwitch), {
            key: 0,
            onEnable: showArchived,
            onDisable: hideArchived
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_ATTACH_CASE_MANAGERS]))
          ? (_openBlock(), _createBlock(_component_AppButton, {
              key: 0,
              type: "text",
              size: "small",
              text: "Add Case Manager",
              "icon-left": "add",
              onClick: openAddCaseManagerModal
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_unref(DataTable), {
        value: caseManagers.value,
        "global-filter-fields": ['name'],
        scrollable: true,
        "loading-icon": "logo-spinner",
        "row-class": ({ archived }) => (archived ? 'grey-row' : null),
        loading: _unref(caseManagerStore).loading,
        "data-key": "name",
        "responsive-layout": "scroll",
        "scroll-height": "440px",
        "state-key": "session-store-case-manager-table",
        "state-storage": "session",
        class: _normalizeClass({ 'table-loading': _unref(caseManagerStore).loading })
      }, {
        empty: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Case Managers not assigned", -1)
        ]))]),
        default: _withCtx(() => [
          (caseManagerCount.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(Column), {
                  field: "name",
                  header: "Case Manager Name",
                  "header-style": "color: #3B4242",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    (data.archived)
                      ? _withDirectives((_openBlock(), _createBlock(_component_Icon, {
                          key: 0,
                          name: "info",
                          class: "mr-1 text-color-gray-dark text-base cursor-pointer"
                        }, null, 512)), [
                          [
                            _directive_tooltip,
                            {
                  value: 'Archived',
                  escape: true,
                  fitContent: true,
                },
                            void 0,
                            { top: true }
                          ]
                        ])
                      : _createCommentVNode("", true),
                    (_unref(can)([_unref(PERMISSIONS).PEOPLE_INDEX]))
                      ? (_openBlock(), _createBlock(_component_RouterLink, {
                          key: 1,
                          to: `/user/${data.id}`,
                          class: "font-semibold",
                          textContent: _toDisplayString(data.name)
                        }, null, 8, ["to", "textContent"]))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: "font-semibold",
                          textContent: _toDisplayString(data.name)
                        }, null, 8, _hoisted_2))
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), {
                  "body-style": "justify-content: center; font-size: .8725rem; max-width: 10rem;",
                  "header-style": "justify-content: center; max-width: 10rem",
                  header: "Actions"
                }, {
                  body: _withCtx(({ data }) => [
                    _createVNode(_component_ActionMenu, {
                      "menu-items": createMenuModel(data),
                      icon: "more_horiz"
                    }, null, 8, ["menu-items"])
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "row-class", "loading", "class"]),
      (caseManagerModalOpen.value && _unref(can)([_unref(PERMISSIONS).ORGANIZATION_ATTACH_CASE_MANAGERS]))
        ? (_openBlock(), _createBlock(AddPersonModal, {
            key: 0,
            title: "Add case managers",
            items: caseManagerItems.value,
            searchable: true,
            "button-text": "Add case managers",
            placeholder: "Search case managers",
            "person-type": "Case manager",
            onAddItems: onSaveAdd,
            onCancel: onCancelAdd
          }, null, 8, ["items"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})